module.exports = __webpack_public_path__ + "static/media/gras.adad3c65.png";